import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "./ui/dialog";

/**
 * Result entry dialog. Two modes:
 *  - Trigger mode: pass a `trigger` element that opens the dialog.
 *  - Controlled mode: pass `open` (boolean) and `onOpenChange`.
 */
export default function ResultDialog({ trigger, open: controlledOpen, onOpenChange, title, playerA, playerB, onSubmit, testIdPrefix = "result" }) {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = typeof controlledOpen === "boolean";
  const open = isControlled ? controlledOpen : internalOpen;
  const setOpen = (v) => { if (isControlled) onOpenChange?.(v); else setInternalOpen(v); };

  const [sa, setSa] = useState(0);
  const [sb, setSb] = useState(0);
  useEffect(() => { if (open) { setSa(0); setSb(0); } }, [open]);

  const submit = () => {
    onSubmit({ score_a: Number(sa), score_b: Number(sb) });
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {trigger ? <DialogTrigger asChild>{trigger}</DialogTrigger> : null}
      <DialogContent className="bg-[#131313] border-white/10 text-white" data-testid={`${testIdPrefix}-dialog`}>
        <DialogHeader><DialogTitle className="font-heading">{title}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3 py-4">
          <label className="block">
            <div className="text-xs text-zinc-500 uppercase tracking-wider mb-1">{playerA?.name || "A"}</div>
            <input type="number" min={0} value={sa} onChange={(e) => setSa(e.target.value)} className="pp-input" data-testid={`${testIdPrefix}-score-a`} />
          </label>
          <label className="block">
            <div className="text-xs text-zinc-500 uppercase tracking-wider mb-1">{playerB?.name || "B"}</div>
            <input type="number" min={0} value={sb} onChange={(e) => setSb(e.target.value)} className="pp-input" data-testid={`${testIdPrefix}-score-b`} />
          </label>
        </div>
        <DialogFooter>
          <button onClick={() => setOpen(false)} className="pp-btn-secondary px-4 py-2 rounded-lg" data-testid={`${testIdPrefix}-cancel`}>Cancel</button>
          <button onClick={submit} className="pp-btn-primary px-4 py-2 rounded-lg" data-testid={`${testIdPrefix}-submit`}>Save</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
